import type { GetStaticProps } from 'next'

import { WordPressApiClient } from '@/utils/WordPressApiClient'

export { OverViewPage as default } from '@/components/pages/Company/OverView'

export const getStaticProps: GetStaticProps = async () => {
  const wpClient = new WordPressApiClient()
  const monthlyReport = await wpClient.fetchMonthlySalesPdfEn()

  return {
    props: {
      monthlyReport: monthlyReport[0],
    },
  }
}
